import {
  CheckCircleOutlined,
  GlobalOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { Flex } from "@p0security/ui";
import { SlackLogo } from "components/Integrations/Slack/Slack";
import React from "react";
import { colors } from "styles/variables";

const iconForSource = (source: string): React.ReactNode => {
  switch (source) {
    case "slack":
      return <SlackLogo size={12} />;
    case "webapp":
      return <GlobalOutlined />;
    case "evidence":
      return <SafetyCertificateOutlined />;
    case "pagerduty":
      return <CheckCircleOutlined />;
    case "grafana-irm":
      return <CheckCircleOutlined />;
    case "persistent":
      return <CheckCircleOutlined />;
    default:
      return null;
  }
};

export const ApprovalSourceIcon: React.FC<{ source: string }> = ({
  source,
}) => {
  const icon = iconForSource(source);
  if (!icon) return null;

  return (
    <Flex
      className="items-center justify-center size-4 rounded-full text-xs"
      /* eslint-disable-line react/forbid-component-props */ style={{
        backgroundColor: colors.neutral["00"],
      }}
    >
      {icon}
    </Flex>
  );
};
